import React, { useEffect, useState } from "react";

import Medusa from "services/api";

import EmailIcon from "@mui/icons-material/Email";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import FeedIcon from "@mui/icons-material/Feed";

import DataTable from "examples/Tables/DataTable";
import Actionables from "components/UpStyled/Actionables";

import { accountTypeOptions, accountStatusOptions } from "utils/data";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiButton from "components/SuiButton";

import { capitalCase } from "capital-case";
import Prompt from "components/UpStyled/Prompt";
import EditUserModal from "pages/admin/users/components/EditUserModal";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

import Switch from "@mui/material/Switch";
import ReactJson from "react-json-view";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import IosShareIcon from "@mui/icons-material/IosShare";
import { Parser } from "@json2csv/plainjs";
import { isSafari } from "utils/helper";

const getInviteStatus = (invite) => {
  return new Date(invite.expires_at) < new Date() ? "expired" : "pending";
};

const UserTable = ({ users, invites, triggerRefetch }) => {
  const [elements, setElements] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [shownElements, setShownElements] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteUser, setDeleteUser] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [detailUser, setDetailUser] = useState(false);
  const [hideInviteUsers, setHideInviteUsers] = useState(true);

  const [confirmEmail, setConfimEmail] = useState(false);
  const [confirmClaimEmail, setConfimClaimEmail] = useState(false);
  const [user_id, setUser_Id] = useState();

  const [selectedInvite, setSelectedInvite] = useState(null);
  const [statusFilter, setStatusFilter] = useState([]);
  const [userVisits, setUserVisits] = useState({});

  useEffect(() => {
    let data = [
      ...users.map((user, i) => ({
        entity: user,
        entityType: "user",
        tableElement: getUserTableRow(user, i),
      })),
      ...invites.map((invite, i) => ({
        entity: invite,
        entityType: "invite",
        tableElement: getInviteTableRow(invite, i),
      })),
    ];
    retrieveUserVisit();

    setRawData(data);
    const hideInvitesData = data.filter((x) => x.entityType != "invite");
    setElements(hideInvitesData);
  }, [users, invites]);

  useEffect(() => {
    let data = [];
    let data1 = [];
    if (hideInviteUsers) {
      data = rawData.filter((x) => x.entityType != "invite");
    } else {
      data = rawData;
    }

    let selectedStatus = statusFilter.map((x) => x.value);
    if (selectedStatus && selectedStatus.length > 0) {
      data1 = data.filter((x) => selectedStatus.includes(x.entity.account_status));
    } else {
      data1 = data;
    }

    setElements(data1);
  }, [hideInviteUsers, statusFilter]);

  useEffect(() => {
    setShownElements(elements);
  }, [elements]);

  const handleEmailClose = () => {
    setConfimEmail(false);
  };

  const formatAccountType = (type) => {
    const option = accountTypeOptions.find((x) => x.value == type);
    return option ? option.label : type;
  };

  const formatAccountStatus = (type) => {
    const option = accountStatusOptions.find((x) => x.value == type);
    if (option) {
      if (option.value == "active") {
        return (
          <SuiBadgeDot
            size="xs"
            color="success"
            badgeContent={<div className="text-gray-800">{option.label} </div>}
          />
        );
      } else if (option.value == "init") {
        return (
          <SuiBadgeDot
            color="warning"
            badgeContent={<div className="text-gray-800">{option.label} </div>}
          />
        );
      } else {
        return (
          <SuiBadgeDot
            color="secondary"
            badgeContent={<div className="text-gray-800">{option.label} </div>}
          />
        );
      }
    } else {
      return type;
    }
  };

  const getUserTableRow = (user, index) => {
    const actions = [
      {
        label: "View Detail",

        onClick: () => {
          setDetailUser(true);
          setSelectedUser(user);
        },
        icon: <FeedIcon fontSize={"small"} />,
      },

      {
        label: "Edit User",
        onClick: () => {
          setEditUser(true);
          setSelectedUser(user);
        },
        icon: <EditRoundedIcon fontSize={"small"} />,
      },
      {
        label: (
          <SuiTypography variant="body" color="error">
            Remove User{" "}
          </SuiTypography>
        ),
        onClick: () => {
          setDeleteUser(true);
          setSelectedUser(user);
        },
        icon: <DeleteForeverRoundedIcon fontSize={"small"} color="error" />,
      },
    ];

    actions.push({
      label: (
        <Link to={`/wall/portfolio/${user.id}`} target="_blank" style={{ color: "inherit" }}>
          View Profile
        </Link>
      ),
      onClick: () => {},
      icon: <AccountBoxIcon fontSize={"small"} />,
    });

    if (user.account_status == "active") {
      actions.push({
        label: "Send Confirm Email",
        onClick: () => {
          setConfimEmail(true);
          setSelectedUser(user);
        },
        icon: <EmailIcon fontSize={"small"} />,
      });
    }

    if (user.account_status == "init") {
      actions.push({
        label: "Send Claim Link",
        onClick: () => {
          setConfimClaimEmail(true);
          setSelectedUser(user);
        },
        icon: <RefreshRoundedIcon fontSize={"small"} />,
      });
    }
    const fullName =
      user.first_name || user.last_name ? `${user.first_name} ${user.last_name}` : user.email;

    const store = user.stores && user.stores.length > 0 ? user.stores[0] : {};
    let lastVisit = "";

    if (userVisits?.[user.id]) {
      let num = Number(userVisits[user.id]);
      if (!isNaN(num)) {
        lastVisit = moment(num).format("YYYY-MM-DD HH:mm:ss");
      }
    }
    let login_times = 0;
    if (user?.metadata?.login_times) {
      login_times = user?.metadata?.login_times;
    }

    return {
      type: "user",
      key: user.email,
      raw_status: user.account_status,
      avatar: store?.metadata?.avatar,
      name: fullName,
      store: store?.name,
      email: user.email,
      permissions: capitalCase(user.role),
      lastVisit: lastVisit,
      account_type: formatAccountType(user.account_type),
      status: user.account_status,
      created_at: user.created_at,
      login_times: login_times,
      action: <Actionables actions={actions} />,
    };
  };

  const getInviteTableRow = (invite, index) => {
    const actions = [
      {
        label: "Resend Invitation",
        onClick: () => {
          Medusa.invites
            .resend(invite.id)
            .then(() => {
              toast.success("Resend invitation successfully!");
            })
            .then(() => triggerRefetch());
        },
        icon: <RefreshRoundedIcon fontSize={"small"} />,
      },
      {
        label: (
          <SuiTypography variant="body" color="error">
            Remove Invitation{" "}
          </SuiTypography>
        ),

        onClick: () => {
          setSelectedInvite(invite);
        },
        icon: <DeleteForeverRoundedIcon fontSize={"small"} color="error" />,
      },
    ];

    const status = new Date(invite?.expires_at) < new Date() ? "Expired" : "Pending";

    return {
      type: "invite",
      key: "invite_" + invite.user_email,
      raw_status: "",
      avatar: "",
      name: invite.user_email,
      store: "",
      email: invite.user_email,
      lastVisit: "",
      permissions: "",
      account_type: "",
      status: status,
      created_at: "",
      login_times: "",
      action: <Actionables actions={actions} />,
    };
  };

  const columns = [
    {
      Header: "Name",
      accessor: "name",

      Cell: ({ row, value }) => {
        return (
          <div className="flex items-center">
            <SuiAvatar
              src={row?.original?.avatar}
              alt="profile-image"
              variant="circle"
              size="sm"
              shadow="sm"
            />

            <div
              className={`${
                row?.original?.type == "user" ? "text-gray-800" : "text-gray-400"
              } ml-2`}
            >
              {value}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Store/Brand",
      accessor: "store",
      Cell: ({ row, value }) => {
        return (
          <div
            className={`${row?.original?.type == "user" ? "text-gray-800" : "text-gray-400"} ml-2`}
          >
            {value}
          </div>
        );
      },
    },
    {
      Header: "email",
      accessor: "email",
      Cell: ({ row, value }) => {
        return (
          <div
            className={`${row?.original?.type == "user" ? "text-gray-800" : "text-gray-400"} ml-2`}
          >
            {value}
          </div>
        );
      },
    },
    {
      Header: "Account Type",
      accessor: "account_type",
      Cell: ({ row, value }) => {
        return (
          <div
            className={`${row?.original?.type == "user" ? "text-gray-800" : "text-gray-400"} ml-2`}
          >
            {value}
          </div>
        );
      },
    },
    {
      Header: "Create At",
      accessor: "created_at",
      Cell: ({ row, value }) => {
        return (
          <div>
            <Tooltip title={moment(value).format("yyyy-MM-DD HH:mm:ss")}>
              <SuiTypography>{moment(value).format("yyyy-MM-DD")}</SuiTypography>
            </Tooltip>
          </div>
        );
      },
    },
    {
      Header: "Last Visit",
      accessor: "lastVisit",
      Cell: ({ row, value }) => {
        return (
          <div>
            <SuiTypography>{value}</SuiTypography>
          </div>
        );
      },
    },
    {
      Header: "Login Times",
      accessor: "login_times",
    },
    {
      Header: "status",
      accessor: "status",
      Cell: ({ row, value }) => {
        const statusBadge =
          value == "Expired" ? (
            <SuiBox>
              <SuiBadgeDot
                size="xs"
                color="error"
                badgeContent={<div className="text-gray-400">{value}</div>}
              />
            </SuiBox>
          ) : (
            <SuiBox>
              <SuiBadgeDot
                size="xs"
                color="success"
                badgeContent={<div className="text-gray-400">{value}</div>}
              />
            </SuiBox>
          );

        return row?.original?.type == "user" ? formatAccountStatus(value) : statusBadge;
      },
    },
    { Header: "More", accessor: "action" },
  ];

  const rows = elements.map((x) => x.tableElement);

  const handleRowClassName = (row) => {
    let className = "";
    if (row?.original?.raw_status == "active") {
      className += "bg-green-400 ";
    }
    return className;
  };

  const handleExportCSV = () => {
    const jsonData = elements.map((x) => {
      const user = x.entity;
      let lastVisit = "";
      if (userVisits?.[user.id]) {
        let num = Number(userVisits[user.id]);
        if (!isNaN(num)) {
          lastVisit = moment(num).format("YYYY-MM-DD HH:mm:ss");
        }
      }

      return { ...user, lastVisit };
    });
    try {
      const opts = {};
      const parser = new Parser(opts);
      const csv = parser.parse(jsonData);
      const type = isSafari ? "application/csv" : "text/csv";
      const uFEFF = true;
      const blob = new Blob([uFEFF ? "\uFEFF" : "", csv], { type });
      let dataURI = `data:${type};charset=utf-8,${uFEFF ? "\uFEFF" : ""}${csv}`;

      const URL = window.URL || window.webkitURL;
      if (typeof URL.createObjectURL != "undefined") {
        dataURI = URL.createObjectURL(blob);
      }
      window.open(dataURI, "_blank");
    } catch (err) {
      console.error(err);
    }
  };

  const retrieveUserVisit = async () => {
    try {
      const { data } = await Medusa.userVisit.list();
      setUserVisits(data?.userVisits || {});
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <SuiBox justifyContent="space-between" display="flex">
        <div className="flex items-center flex-wrap gap-3 ml-6">
          <SuiBox className="flex items-center">
            <SuiTypography variant="text" textTransform="capitalize" mr={1}>
              Hide invites
            </SuiTypography>
            <Switch
              defaultChecked={hideInviteUsers}
              checked={hideInviteUsers}
              onChange={(e) => {
                setHideInviteUsers(e.target.checked);
              }}
            />
          </SuiBox>
          <SuiBox className="flex items-center">
            <SuiTypography variant="text" textTransform="capitalize" mr={1}>
              Filter:
            </SuiTypography>
            <SuiSelect
              defaultValue={{ value: "all", label: "ALL" }}
              isMulti
              closeMenuOnSelect={false}
              value={statusFilter}
              options={accountStatusOptions}
              onChange={(value) => setStatusFilter(value)}
            />
          </SuiBox>
        </div>
        <SuiButton
          variant="outlined"
          color="dark"
          sx={{ mr: 2, py: 0, px: 2 }}
          onClick={handleExportCSV}
        >
          <IosShareIcon />
          Export CSV
        </SuiButton>
      </SuiBox>
      <DataTable
        table={{ columns, rows: rows }}
        entriesPerPage={{
          defaultValue: 20,
          entries: [10, 20, 50, 100, 500],
        }}
        handleRowClassName={handleRowClassName}
        canSearch
      />
      {/**View User Detail info */}
      {detailUser ? (
        <Prompt
          option={{ fullWidth: true, maxWidth: "md" }}
          text={<ReactJson src={selectedUser} enableClipboard={true} />}
          heading={`Details for user: ${selectedUser.email}`}
          visible={detailUser}
          okText="Ok"
          handleOk={() => setDetailUser(false)}
          handleClose={() => setDetailUser(false)}
        />
      ) : null}
      {/**Delete user */}
      {selectedUser && deleteUser ? (
        <Prompt
          heading="Delete User"
          text={`Are you sure you want to delete user: ${selectedUser.email}`}
          visible={deleteUser}
          okText="Delete"
          okColor="error"
          handleOk={() =>
            Medusa.users.delete(selectedUser.id).then(() => {
              toast.success(`Delete user ${selectedUser.email} successfully!`);
              triggerRefetch();
              setDeleteUser(false);
            })
          }
          handleClose={() => setDeleteUser(false)}
        />
      ) : null}
      {/**Delete invitation */}
      {selectedInvite && (
        <Prompt
          text={`Are you sure you want to delete the invitation for user: ${selectedInvite.user_email}`}
          heading="Delete Invitation"
          visible={selectedInvite}
          okText="Delete"
          okColor="error"
          handleOk={() =>
            Medusa.invites.delete(selectedInvite.id).then(() => {
              toast.success(`Delete invitation ${selectedInvite.user_email} successfully!`);
              setSelectedInvite(false);
              triggerRefetch();
            })
          }
          handleClose={() => setSelectedInvite(false)}
        />
      )}
      {/**Send edit user */}
      {selectedUser && editUser ? (
        <EditUserModal
          handleClose={() => setEditUser(false)}
          visible={editUser}
          user={selectedUser}
          onSubmit={() => {
            triggerRefetch();
            setEditUser(false);
          }}
        />
      ) : null}
      {/**Send confirmation email */}
      {confirmEmail && (
        <Prompt
          heading="Send Confirm Email"
          text={
            <SuiBox display="flex">
              <SuiTypography variant="h6">This will send a </SuiTypography>
              <SuiTypography variant="h6" fontWeight="bold" color="error" mx={1}>
                confirmation email
              </SuiTypography>
              <SuiTypography variant="h6">to user:{selectedUser.email}</SuiTypography>
            </SuiBox>
          }
          visible={confirmEmail}
          okText="Send"
          okColor="warning"
          handleOk={() =>
            Medusa.sendConfirmEmail
              .sendEmail({ user_id: selectedUser.id })
              .then((data) => {
                toast.success("Send confirmation email successfully!");

                setConfimEmail(false);
              })
              .catch((err) => toast.error("Send confirmation email failed!"))
          }
          handleClose={() => setConfimEmail(false)}
        />
      )}
      {/**Send claim email */}
      {confirmClaimEmail && (
        <Prompt
          heading="Send Claim Email"
          text={
            <SuiBox display="flex">
              <SuiTypography variant="h6">This will send a </SuiTypography>
              <SuiTypography variant="h6" fontWeight="bold" color="error" mx={1}>
                claim email
              </SuiTypography>
              <SuiTypography variant="h6">to user:{selectedUser.email}</SuiTypography>
            </SuiBox>
          }
          visible={confirmClaimEmail}
          okText="Send"
          okColor="warning"
          handleOk={() =>
            Medusa.invites
              .create({
                claim_user_id: selectedUser.id,
                user: selectedUser.email,
                account_type: selectedUser.account_type,
                role: "member",
              })
              .then(() => {
                toast.success("Send claim link successfully!");
                triggerRefetch();
                setConfimClaimEmail(false);
              })
              .catch((err) => toast.error("Send claim link failed!"))
          }
          handleClose={() => setConfimClaimEmail(false)}
        />
      )}
    </div>
  );
};

export default UserTable;
